import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import Tabs from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Tabs';
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import TriggleIcon from './TriggleIcon';
import styles from './index.module.scss';

const Output: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Output');
    const swiperRef = useRef<any>(null);

    const [activeIndex, setActiveIndex] = useState(0);
    const tabs = [
        {
            tabLabel: t('tab1'),
            tabValue: 'a1',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538584271-e7knfd-compressed-Kitchen.jpg',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758538712727-ds61kv-compressed-Kitchen.jpg',
            things: [t('tab1_thing1'), t('tab1_thing2'), t('tab1_thing3'), t('tab1_thing4'), t('tab1_thing5')],
        },
        {
            tabLabel: t('tab2'),
            tabValue: 'a2',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538608778-fdc480-compressed-Living%20Room.jpg',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758538723462-s7du1l-compressed-Living%20Room.jpg',
            things: [t('tab2_thing1'), t('tab2_thing2'), t('tab2_thing3'), t('tab2_thing4')],
        },
        {
            tabLabel: t('tab3'),
            tabValue: 'a3',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538619104-dn1jru-compressed-Laundry%20Room.jpg',

            pad: '',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758538733255-5ez999-compressed-Laundry%20Room.jpg',
            things: [t('tab3_thing1'), t('tab3_thing2'), t('tab3_thing3'), t('tab3_thing4')],
            title: t('tab3_title'),
            desc: t('tab3_desc'),
        },
        {
            tabLabel: t('tab4'),
            tabValue: 'a4',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538632718-9a1weh-compressed-Office.jpg',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1759025861991-xrzrkz-compressed-Office.jpg',
            things: [t('tab4_thing1'), t('tab4_thing2'), t('tab4_thing3'), t('tab4_thing4')],
            desc: t('tab4_desc'),
            title: t('tab4_title'),
        },
        {
            tabLabel: t('tab5'),
            tabValue: 'b1',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538643698-532wvo-compressed-RV%20Camping.jpg',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758538751454-m9g0bi-compressed-RV%20Camping.jpg',
            things: [t('tab5_thing1'), t('tab5_thing2'), t('tab5_thing3'), t('tab5_thing4'), t('tab5_thing5')],
            title: t('tab5_title'),
            desc: t('tab5_desc'),
        },
        {
            tabLabel: t('tab6'),
            tabValue: 'b2',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538654591-0chho6-compressed-Garage.jpg',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758597668080-c6yrk6-compressed-Garage.jpg',
            things: [t('tab6_thing1'), t('tab6_thing2'), t('tab6_thing3'), t('tab6_thing4'), t('tab6_thing5')],
            desc: t('tab6_desc'),
            title: t('tab6_title'),
        },
    ];

    const onChange = (item: any, index: number) => {
        setActiveIndex(index);
        swiperRef.current.slideTo(index);
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);
    };

    return (
        <div className={`${styles.Output} GtmModuleData-section`} id="Output" data-section-id="d3m-output">
            <EcoSpace hPc="160px" hPad="100px" hH5="60px" />
            <EcoSectionCommon className="d3m-title-common" title={t('title')} desc={t('desc')} />

            <div className="swiper-output d3m-layout">
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    slidesPerView={1}
                    spaceBetween={12}
                    // modules={[Navigation]}
                    // navigation={{
                    //     nextEl: '.swiper-button-next',
                    //     prevEl: '.swiper-button-prev',
                    // }}
                    initialSlide={0}
                    onSlideChange={handleSlideChange}
                >
                    {tabs.map((item, index) => (
                        <SwiperSlide key={index} className={`list-item list-item-${index + 1}`}>
                            <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} isOpenLazy={true} />
                            <div className="things things-${index + 1}">
                                {item.things.map((thing, _index) => (
                                    <div key={_index} className={`thing thing-${index + 1}_${_index + 1}`}>
                                        {thing}

                                        <TriggleIcon className="triggle-icon" />
                                    </div>
                                ))}

                                {(item.title || item.desc) && (
                                    <div className="desc-wrapper ">
                                        {item.title && <div className="title">{item.title}</div>}
                                        {item.desc && <div className="desc">{item.desc}</div>}
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                    {/* <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} /> */}
                </Swiper>
            </div>
            <div className="d3m-tabs">
                <Tabs gtmTitle={t('title')} tabs={tabs} activeIndex={activeIndex} onChange={onChange} />
            </div>
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
        </div>
    );
};

export default Output;
